import Dashboard from 'viewsOld/Dashboard'

const DashboardPage = () => {
    return <Dashboard />
}

export default DashboardPage
